import { InjectionToken } from '@angular/core';

export const API_HOST = new InjectionToken<string>('Swagger Api Host');
